import React from 'react';
import { Typography } from '@one-thd/sui-atomic-components';
import { useSelector } from 'react-redux';
import { Wrapper } from './styles';
import { totalProjectPrice } from '../../selectors/pricing';

const HeaderContent = () => {
  const carpetPrice = useSelector(totalProjectPrice) || 0;
  const price = (carpetPrice === '' || carpetPrice === '0.00' || carpetPrice === 'NaN')
    ? '---' : `$${(carpetPrice * 1).toLocaleString('en-EN', { minimumFractionDigits: 2 })}`;

  return (
    <Wrapper>
      <Typography variant="h3" style={{ fontSize: '20px', fontWeight: 'bold' }}>Total Cost Estimate:</Typography>
      <Typography variant="h3" style={{ fontSize: '18px', paddingTop: '3px', fontWeight: 'bold' }}>{price}</Typography>
    </Wrapper>
  );
};
export default HeaderContent;